import { types } from 'mobx-state-tree';

export const CategoryItem = types.model('CategoryItem', {
  _id: types.identifier,
  contentType: types.string,
  image: types.maybeNull(types.union(types.string, types.number)),
  humanReadableId: types.maybeNull(types.string),
  order: types.number,
  contentId: types.string,
  title: types.string,
  designSystemColor: types.maybeNull(types.string),
  activityType: types.maybeNull(types.string),
  /** the session that plays this item (survey, content and activity are launched through it) */
  sessionId: types.maybeNull(types.string),
});
